import Home from "./Pages/Home";
import Navigation from "./Components/Navigation"

import { BrowserRouter as Router,Routes,Route } from 'react-router-dom'

import background from './Assets/Home/background.png'

import Samples from './Pages/Samples'

function App() {
  return (
    
    <Router>
    <div style={{backgroundImage:`url(${background})`,backgroundSize:"cover",}}>
      <div style={{background:'rgba(255,255,255,0.8)'}}>
        <Navigation/>
        <Routes>
          <Route path='/' element={<Home/>}/>
          <Route path="/Samples" element={<Samples/>} />
        </Routes>
      </div>
    </div>
    </Router>
  );
}

export default App;
